export default __webpack_public_path__ + "static/desks-c6da526442a2468029949b36d0e9e1f9.svg";